import React from 'react';
import PropTypes from 'prop-types';

import config from '../../../../config';

function AppLogo({ style, ...props }) {
    return (
        <picture>
            <img
                src={`${config.staticUrl}assets/images/logo-monlivresms-2.png`}
                alt={config.application.name}
                width="168"
                height="46"
                style={{ height: 'auto', ...style }}
                {...props}
            />
        </picture>
    );
}

AppLogo.defaultProps = {
    suffix: '',
};

AppLogo.propTypes = {
    suffix: PropTypes.string,
};

export default AppLogo;
